<hpf-video-form
        [video]="video"
        [loading]="video.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-video-form>
<div class="container">
</div>
